module.exports = __webpack_public_path__ + "img/eye.e466e1a4.svg";